import { useAppSelector } from "../../../../redux";
import { ArticleProps } from "../../../../redux/slices/article/Article";

export const useFindContent = (id: number) => {
  const { body_content } = useAppSelector(
    (state) => state.article.draftArticle
  );

  const articleContent = body_content.find(
    (content) => content.id === id
  ) as ArticleProps.Content;
  return articleContent;
};
